<div class="fixed bottom-5 right-5 z-50">
  <div class="relative flex flex-col items-end">

    @if (isMenuOpen || isAnimatingOut) {
      <div class="flex flex-col items-end gap-3 mb-3">
        <div class="flex items-center gap-2" [class.animate-slide-up]="!isAnimatingOut" [class.animate-slide-down]="isAnimatingOut">
          <span class="bg-gray-800 text-white text-xs px-3 py-1.5 rounded-lg shadow-lg whitespace-nowrap">
            Solicitar Ayuda
          </span>
          <button
            (click)="onHelp()"
            class="rounded-full bg-[#25D366] shadow-lg hover:scale-110 active:scale-95 transition-all duration-300 w-12 h-12 flex items-center justify-center"
          >
            <img src="svg/whatsapp.svg" alt="WhatsApp" class="w-6 h-6">
          </button>
        </div>
        <div class="flex items-center gap-2" [class.animate-slide-up]="!isAnimatingOut" [class.animate-slide-down]="isAnimatingOut" [style.animation-delay]="!isAnimatingOut ? '0.1s' : '0s'">
          <span class="bg-gray-800 text-white text-xs px-3 py-1.5 rounded-lg shadow-lg whitespace-nowrap">
            Abandonar
          </span>
          <button
            (click)="onReset()"
            class="rounded-full bg-red-500 shadow-lg hover:scale-110 active:scale-95 transition-all duration-300 w-12 h-12 flex items-center justify-center"
          >
            <svg xmlns="http://www.w3.org/2000/svg" class="w-6 h-6 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
            </svg>
          </button>
        </div>

      </div>
    }

    <div class="relative">
      <div
        (click)="toggleMenu()"
        class="w-14 h-14 rounded-full flex justify-center items-center shadow-lg cursor-pointer transition-all duration-300 active:scale-95"
        [class.bg-red-500]="isMenuOpen && !isAnimatingOut"
        [style.background]="(!isMenuOpen || isAnimatingOut) ? 'linear-gradient(to bottom, ' + colorOne + ', ' + colorTwo + ')' : ''"
      >
        @if (!isMenuOpen || isAnimatingOut) {
          <svg xmlns="http://www.w3.org/2000/svg" class="w-7 h-7 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        }

        @if (isMenuOpen && !isAnimatingOut) {
          <svg xmlns="http://www.w3.org/2000/svg" class="w-7 h-7 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        }
      </div>

      @if (isHelpMessageVisible && !isMenuOpen) {
        <div class="absolute top-full left-1/2 transform -translate-x-1/2 mt-2 bg-gray-800 text-white text-xs px-2 py-1 rounded shadow-lg whitespace-nowrap">
          Ayuda
        </div>
      }
    </div>

  </div>
</div>

@if (isConfirmModalVisible) {
  <div class="fixed inset-0 flex items-center justify-center bg-black/60 backdrop-blur-sm z-[60]">
    <div class="bg-white rounded-2xl shadow-2xl max-w-md w-full mx-4 transform transition-all animate-modal-slide-in">
      <div class="rounded-t-2xl px-6 py-4" [style.background]="'linear-gradient(to bottom, ' + colorOne + ', ' + colorTwo + ')'">
        <h3 class="text-white text-xl font-semibold">Confirmar Abandono</h3>
      </div>
      <div class="p-6">
        <div class="flex justify-center mb-4">
          <div class="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
        </div>
        <p class="text-gray-700 text-center mb-2 font-medium">
          ¿Estás seguro que deseas abandonar el proceso?
        </p>
        <p class="text-gray-500 text-center text-sm mb-4">
          Tendrás que volver a ingresar la información.
        </p>
      </div>
      <div class="px-6 pb-6 flex gap-3">
        <button
          (click)="closeConfirmModal()"
          class="flex-1 px-4 py-2 bg-gray-200 text-gray-800 rounded-lg hover:bg-gray-300 transition-colors font-medium"
        >
          Cancelar
        </button>
        <button
          (click)="confirmReset()"
          class="flex-1 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-all font-medium hover:opacity-90"
        >
          Sí, abandonar
        </button>
      </div>
    </div>
  </div>
}
